import { VoiceCallService } from '../services/voice-call.service';

/**
 * Common utility for fetching schedules with product type filtering
 * @param {Object} params - Parameters for fetching schedules
 * @param {string} params.locationId - The location ID
 * @param {string} params.scheduleId - The schedule ID (optional)
 * @param {string} params.productType - The product type to filter by ('voice' or 'video')
 * @returns {Promise<Array>} Filtered schedules array
 */
export const fetchScheduleSettings = async ({ locationId, scheduleId, productType }) => {
  const voiceCallService = new VoiceCallService();

  try {
    const data = await voiceCallService.getScheduledList({ locationId, scheduleId });
    // Filter schedules based on product type
    return data.content.flatMap(content => 
      content.schedule.filter(schedule => schedule.productType === productType)
    );
  } catch (error) {
    throw new Error(error.message);
  }
};
